import { objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { v4 } from 'uuid';
import { keys } from '../constants/keys.esm.js';
import { LayoutType } from '../types/layouts.esm.js';
import { getNewLayoutId } from './get-new-layout-id.esm.js';
import { sortLayouts } from './sort-layouts.esm.js';
import { trim } from './trim.esm.js';

function trimName(layout, resources) {
  switch (layout.type) {
    case LayoutType.Default:
      {
        return trim(layout.label) || resources["default"]();
      }
    case LayoutType.Custom:
      {
        return trim(layout.label) || resources.custom();
      }
    default:
      {
        var id = layout.id || v4();
        return trim(layout.label) || id;
      }
  }
}
function reducerToReverseOrder(agg, item) {
  return [item].concat(_toConsumableArray(agg));
}
var getFixFieldsFunction = function getFixFieldsFunction(lockedFields) {
  return function (fields) {
    if (!(fields !== null && fields !== void 0 && fields.length)) {
      return lockedFields;
    }
    return lockedFields.reduce(reducerToReverseOrder, []).reduce(function (agg, lockedField) {
      if (agg.includes(lockedField)) {
        return agg;
      } else {
        return [lockedField].concat(_toConsumableArray(agg));
      }
    }, fields);
  };
};
var getContainsLockedFieldsFunction = function getContainsLockedFieldsFunction(lockedFields) {
  return function (fields) {
    if (fields === undefined || fields === null) {
      return false;
    }
    return !lockedFields.some(function (lockedField) {
      return !fields.includes(lockedField);
    });
  };
};
var normalizeLayouts = function normalizeLayouts(resources, lockedFields) {
  return function (layouts) {
    var _result;
    var checkFields = getFixFieldsFunction(lockedFields);
    var containsLockedFields = getContainsLockedFieldsFunction(lockedFields);
    var result = layouts;
    //Add a default layout if there is none
    if (!((_result = result) !== null && _result !== void 0 && _result.length)) {
      result = [{
        type: LayoutType.Default,
        label: resources["default"](),
        id: keys["default"],
        selected: true,
        fields: lockedFields
      }];
    }
    //Ensure all fields are not null/undefined
    if (result.some(function (l) {
      return !containsLockedFields(l.fields);
    })) {
      result = result.map(function (l) {
        return _objectSpread2(_objectSpread2({}, l), {}, {
          fields: checkFields(l.fields)
        });
      });
    }
    //Ensure all ids are correct
    if (result.some(function (l) {
      return l.id !== getNewLayoutId(l).id;
    })) {
      result = result.map(getNewLayoutId);
    }
    //Ensure all labels are trimmed
    if (result.some(function (l) {
      return l.label !== trimName(l, resources);
    })) {
      result = result.map(function (l) {
        return _objectSpread2(_objectSpread2({}, l), {}, {
          label: trimName(l, resources)
        });
      });
    }
    //Ensure the selected flag is not undefined
    if (result.some(function (l) {
      return l.selected === undefined || l.selected === null;
    })) {
      result = result.map(function (l) {
        return _objectSpread2(_objectSpread2({}, l), {}, {
          selected: l.selected || false
        });
      });
    }
    //Add a default layout if there is none
    if (!result.some(function (l) {
      return l.type === LayoutType.Default;
    })) {
      var hasSelectedLayout = result.filter(function (l) {
        return l.selected;
      }).length > 0;
      result = [getNewLayoutId({
        type: LayoutType.Default,
        label: resources["default"](),
        selected: !hasSelectedLayout,
        fields: lockedFields
      })].concat(_toConsumableArray(result));
    }
    //If no layout is selected, select the default one
    if (!result.some(function (l) {
      return l.selected;
    })) {
      result = result.map(function (l) {
        var selected = l.type === LayoutType.Default;
        return getNewLayoutId(_objectSpread2(_objectSpread2({}, l), {}, {
          selected: selected
        }));
      });
    }
    //Removed any custom layout if it is not selected
    if (result.some(function (l) {
      return !l.selected && l.type === LayoutType.Custom;
    })) {
      result = result.filter(function (l) {
        return l.selected || l.type !== LayoutType.Custom;
      });
    }
    return sortLayouts(result);
  };
};

export { getContainsLockedFieldsFunction, getFixFieldsFunction, normalizeLayouts };
//# sourceMappingURL=normalize-layouts.esm.js.map
